import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import type { DailyIdeaFeed } from "@/types/marketing";

const sections: Array<{ key: keyof DailyIdeaFeed; title: string; description: string }> = [
  { key: "trending_topics", title: "Trending Topics", description: "Cross-platform pulse" },
  { key: "suggested_sounds", title: "Suggested Sounds", description: "Reels & TikTok" },
  { key: "video_ideas", title: "Video Ideas", description: "Storyboard-ready prompts" },
  { key: "caption_prompts", title: "Caption Prompts", description: "Kickstart copy" },
  { key: "hashtags", title: "Hashtags", description: "Blend evergreen + moment" },
];

export function IdeaFeed({ data, loading }: { data?: DailyIdeaFeed | null; loading?: boolean }) {
  const resolved = data ?? {
    trending_topics: [],
    suggested_sounds: [],
    video_ideas: [],
    caption_prompts: [],
    hashtags: [],
  };

  return (
    <Card className="space-y-4 border-border/70 bg-background/40 p-4">
      <div>
        <p className="text-sm font-semibold text-foreground">Daily Ideation Feed</p>
        <p className="text-xs text-muted-foreground">AI-curated inspiration across platforms.</p>
      </div>
      {loading ? (
        <p className="text-sm text-muted-foreground">Collecting trends…</p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {sections.map((section) => {
            const items = resolved[section.key] ?? [];
            return (
              <div key={section.key} className="rounded-2xl border border-border/70 bg-background/40 p-4">
                <p className="text-sm font-semibold text-foreground">{section.title}</p>
                <p className="text-xs text-muted-foreground">{section.description}</p>
                <div className="mt-3 space-y-2">
                  {items.length ? (
                    items.map((entry) => (
                      <Badge key={entry} variant="outline" className="block w-full border-border/70 bg-background/60 text-left text-foreground/80">
                        {entry}
                      </Badge>
                    ))
                  ) : (
                    <p className="text-xs text-muted-foreground">No signals yet.</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
